import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { $axios } from '@app/utils/api'
import { buildKintoneHealthUrl } from '@app/utils/kintoneHealthUrl'

export type KintoneHealthStatus = 'unknown' | 'ok' | 'ng'

@Module({
  name: 'kintoneHealth',
  stateFactory: true,
  namespaced: true,
})
export default class KintoneHealthModule extends VuexModule {
  status: KintoneHealthStatus = 'unknown'

  blockedFrom: string | null = null

  @Mutation
  public setStatus(status: KintoneHealthStatus) {
    this.status = status
  }

  @Mutation
  public setBlockedFrom(path: string | null) {
    this.blockedFrom = path
  }

  /**
   * Kintone 疎通確認 API を 1 回呼び、status を更新する。
   *
   * 契約どおりの NG 応答（HTTP 503 かつ success === false）だけを 'ng' とし、
   * それ以外（ネットワークエラー・タイムアウト・契約外の応答）はすべて
   * 'unknown' にする（フェイルオープン）。**決して reject しない。**
   */
  @Action({ rawError: true })
  public async check(): Promise<void> {
    this.setStatus('unknown')

    try {
      const response = await $axios.get(
        buildKintoneHealthUrl(process.env.BASE_PATH_V3 as string),
        { timeout: 10000 }
      )
      const data = response?.data
      if (
        response?.status === 200 &&
        data &&
        typeof data === 'object' &&
        data.success === true &&
        data.data?.status === 'ok'
      ) {
        this.setStatus('ok')
      }
      // 200 だが期待した形でない場合は unknown のまま
    } catch (e: any) {
      const response = e?.response
      if (
        response?.status === 503 &&
        response?.data &&
        typeof response.data === 'object' &&
        response.data.success === false
      ) {
        this.setStatus('ng')
        return
      }
      // ネットワークエラー・タイムアウト・503以外の4xx/5xx・契約外の body は unknown のまま
      console.warn('[kintoneHealth] health check failed', e?.message)
    }
  }
}
